import React, { useState } from 'react';
import { api } from '../../lib/api';

export default function WaitlistForm({ address, lat, lng, accessInstructions }) {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await api.post('/api/waitlist', {
                email,
                requestedAddress: address,
                lat,
                lng,
                accessInstructions
            });

            if (!response.ok) {
                throw new Error('Failed to join waitlist');
            }

            setSubmitted(true);
        } catch (err) {
            console.error(err);
            setError('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (submitted) {
        return (
            <div className="waitlist-card success">
                <h3>Thanks! We'll be in touch. 💌</h3>
                <p>You've been added to our Metro Vancouver expansion specific waitlist.</p>
            </div>
        );
    }

    return (
        <div className="waitlist-card">
            <div className="waitlist-header">
                <h3>We aren't there yet! 🚧</h3>
                <p>Glaminant currently serves the Metro Vancouver area.</p>
                <p>Leave your email below, and you'll be the first to know when we bring our luxury services to <strong>{address}</strong>.</p>
            </div>

            <form onSubmit={handleSubmit} className="waitlist-form">
                <input
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="form-input"
                />
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                >
                    {loading ? 'Joining...' : 'Notify Me'}
                </button>
            </form>
            {error && <p className="error-msg">{error}</p>}
        </div>
    );
}
